import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { waLink } from "@/lib/whatsapp";

export const WhatsAppFloat = () => {
  const { t } = useLang();
  const { pathname } = useLocation();

  if (pathname === "/contact") return null;

  return (
    <motion.a
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6 }}
      href={waLink(t.nav.waMessage)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-action-button"
      aria-label="WhatsApp"
      className="group fixed bottom-5 right-5 z-40 sm:bottom-7 sm:right-7"
    >
      <span className="absolute inset-0 rounded-full bg-teak/60 animate-pulse-ring" />
      <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-espresso text-offwhite shadow-lg transition-colors duration-300 group-hover:bg-teak sm:h-14 sm:w-14">
        <MessageCircle className="h-5 w-5 sm:h-6 sm:w-6" />
      </span>
    </motion.a>
  );
};
